import { iChainBase } from "@models/ChainBase";
import { NO_VALUE_PLACEHOLDER } from "@models";
import { getFormattedThousandWithDecimal } from "@helpers";

export function getChainsClipboardData(
    head: string[],
    data: iChainBase[],
    isMenuCountColumnVisible: boolean,
): string[][] {
    return [
        head,
        ...data.map(item => {
            const row = [
                item.name,
                item.metroArea,
                item.stateFullName,
                item.sales ? `$${getFormattedThousandWithDecimal(item.sales / 10 ** 6, 1)}` : NO_VALUE_PLACEHOLDER,
                `${item.numberOfUnits || NO_VALUE_PLACEHOLDER}`,
                `${item.unitsGrowth || NO_VALUE_PLACEHOLDER}`,
                item.segment,
                item.menuType
            ];
            if (isMenuCountColumnVisible) {
                row.push(item.menuItemCount != null ? `${item.menuItemCount}` : NO_VALUE_PLACEHOLDER);
            }
            return row;
        })
    ];
}
